export const CHANGE_THEME = "CHANGE_THEME";

export const handleChangeTheme = (theme) => ({
  type: CHANGE_THEME,
  payload: theme,
});
